import React, { Component } from 'react';
import './Works.css';
import { motion, useAnimation } from "framer-motion";
import "fullpage.js/vendors/scrolloverflow"; // Optional. When using scrollOverflow:true
import ReactFullpage from "@fullpage/react-fullpage";
import DarkModeToggle from '../Dark/DarkModeToggle';
import '../Dark/styles.scss';

class Works extends Component {
  onLeave(origin, destination, direction) {
    console.log("Leaving section " + origin.index);
  }
  afterLoad(origin, destination, direction) {
    console.log("After load: " + destination.index);
  }
  render() {
    
    return (
      <section id="works">
      
      <ReactFullpage
        scrollOverflow={true}
        onLeave={this.onLeave.bind(this)}
        lazyLoading="true"
        slidesNavigation="true"
        afterLoad={this.afterLoad.bind(this)} 
        render={({ state, fullpageApi }) => {
          return (
            <div id="fullpage-wrapper"  >
            <div class="section" fp-noscroll   >
            
                <div className="slide" >
                <div className="TitleW">WORKS</div>
                  <div className="slide1"> 
                      <div className="slide1Left" > </div>
                    <div className="slide1Right">
                          <div className="TitleRight" >Appetizer</div>
                          <div className="subTitle"> <span>-MDG, IIT Roorkee</span></div>
                          <div className="subTitle"> <span>Uses React, Typescript, Node,  React Hooks and Redux. </span></div>
                              
                              <div className="para"><p>A project for the official Messing App of IIT Roorkee. The features involves Updation of Weekly Menu through dynamic database stored at the Server-end and many more. Built using React and Typescript. It includes Redux and Hooks.</p></div>
                              <div className="B"> 
                                        <a href="https://mess.iitr.ac.in">
                                        <motion.button
                                           className="btn"
                                          
                                          whileHover={{ scale: 1.1 }}
                                           whileTap={{ scale: 0.9 }}>
                                              LIVE VIEW

                                       </motion.button>    </a>                       </div>
                    </div>

                  </div>
                </div>
                <div className="slide">
                <div className="TitleW">WORKS</div>
                <div className="slide1"> 
                <div className="slide2Left"></div>
                <div className="slide1Right">
                          <div className="TitleRight">QuickChat</div> 
                          <div className="subTitle"> <span>-Startup</span></div>  
                          <div className="subTitle"> <span>Uses React, Typescript, Node and JavaScript. </span></div>
                          
                              
                              <div className="para"><p>An online chatting web application. It enables user to chat quickly and hassle free without verifying any account. Just Singup and you are done. The features include Realtime Chatting by adding the usernames.</p></div>
                              <div className="B"> 
                                        <a href="https://quickchat-redis.herokuapp.com/">
                                        <motion.button
                                           className="btn"
                                          
                                          whileHover={{ scale: 1.1 }}
                                           whileTap={{ scale: 0.9 }}>
                                              LIVE VIEW

                                       </motion.button>    </a>                       </div>
                    </div>
                </div>
                </div>
                <div className="slide">
                <div className="TitleW">WORKS</div>
                <div className="slide1" > 
                <div className="slide3Left"></div>
                <div className="slide1Right">
                          <div className="TitleRight">BurgerBuilder</div>
                          <div className="subTitle"> <span>-Personal Project</span></div>
                          <div className="subTitle"> <span>Uses React, JavaScript, React Hooks and Redux </span></div>
                              
                              <div className="para"><p>A Buger-Builder Web App where you can add the ingredients according to your need. The features include Authentication, Storing orders and Contact data all on realtime database. Built using React.js including Hooks and Redux. </p></div>
                              <div className="B"> 
                                        <a href="https://mohdzaryab.github.io/burger-builder">
                                        <motion.button
                                           className="btn"
                                          
                                          whileHover={{ scale: 1.1 }}
                                           whileTap={{ scale: 0.9 }}>
                                              LIVE VIEW

                                       </motion.button>    </a>                       </div>
                    </div>
                </div>
                </div>
                <div className="slide">
                <div className="TitleW">WORKS</div>
                <div className="slide1" > 
                <div className="slide4Left"></div>
                <div className="slide1Right">
                          <div className="TitleRight">SilentMe</div>
                          <div className="subTitle"> <span>-Personal Project</span></div>
                          <div className="subTitle"> <span>Uses Kotlin, Geofencing and Google Maps API. </span></div>
                              
                              <div className="para"><p>Built using Kotlin, it is an Android Application which sets your device on Silent Mode according to the locations selected by you. Works on the princliple of Geofencing and data is stored locally. Device gets to ringer mode as soon as you leave your SILENT location.</p></div>
                              
                                                    
                    </div>
                </div>
                </div>
              </div>
              
            </div>
          );
        }}
      />
          

        </section>
    );
  }
}

export default Works;